import { apiClient } from '../../api/client';
import { endpoints } from '../../api/endpoints';
import type { CartDto, UpdateCartRequest } from '../../types/api';

export async function httpFetchCart(): Promise<CartDto> {
  return apiClient<CartDto>(endpoints.cart.get);
}

export async function httpUpdateCart(payload: UpdateCartRequest): Promise<CartDto> {
  return apiClient<CartDto>(endpoints.cart.update, {
    method: 'PUT',
    body: payload,
  });
}

export async function httpClearCart(): Promise<void> {
  await apiClient<void>(endpoints.cart.clear, { method: 'DELETE' });
}
